import React from "react";
import Layout from "../Layout/Layout";

const ContactUs = () => {
  return (
    <Layout>
      <h2>this is  contactus</h2>
    </Layout>
  );
};

export default ContactUs;
